export enum Paths {
  ChannelTabConfig = '/channelTabConfig',
  ChannelTabRemove = '/channelTabRemove',
  EmailGetStarted = '/emailRoot/getStarted',
  EmailRoot = '/emailRoot',
  EmailTicketDetails = '/emailRoot/ticketDetails/:id',
  EmailTicketListRoot = '/emailRoot/ticketListRoot',
  EmailTicketListTickets = '/emailRoot/ticketListRoot/tickets'
}
